import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function VegetableEnchiladas() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">VegetableEnchiladas</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>2 red or yellow peppers
        <br></br>2 corn on the cob<br></br>
        Olive oil<br></br>1 x 400g tin black beans<br></br>½ teaspoon ground
        cumin<br></br>6 spring onions<br></br>1 fresh red chilli<br></br>1 bunch
        of fresh coriander , (30g)<br></br>1 lime<br></br>2 cloves of garlic
        <br></br>1 x 400g tin quality plum tomatoes<br></br>8 small corn
        tortillas<br></br>
        70 g mature Cheddar cheese<br></br>
        40 g feta cheese<br></br>
      </Typography>

      <Typography>
        Preheat the oven to 200°C/400°F/gas 6.<br></br>
        Place a griddle pan over a high heat to get smoking hot.<br></br>
        <br></br>
        Halve and deseed the peppers, then add to the griddle with the corn.
        <br></br>
        Grill for 8 to 10 minutes, or until charred and bar-marked, turning
        occasionally.<br></br>
        Remove to a plate to cool.<br></br>
        <br></br>
        Heat 1 tablespoon of oil in a medium frying pan over a medium heat.
        <br></br>
        Drain and add the black beans, stir in the cumin and fry for 4 to 5
        minutes, or until crisp, stirring occasionally.<br></br>
        <br></br>
        Once cooled, cut the corn kernels away from the cob and chop the peppers
        into 1.5cm chunks. <br></br>
        Reserving 1 tablespoon of the corn, add to a large bowl with the peppers
        and black beans.<br></br>
        <br></br>
        Trim, finely slice and add the spring onions, reserving a small handful
        to one side. <br></br>
        Deseed, finely slice and add the chilli. <br></br>
        Pick and add most of the coriander leaves, reserving the stalks.
        <br></br>
        <br></br>
        Squeeze in the lime juice and season well with sea salt and black
        pepper.<br></br>
        <br></br>
        Wipe the frying pan clean with kitchen paper, then return to a medium
        heat with 1 tablespoon of oil.<br></br>
        <br></br>
        Peel and finely slice the garlic and finely slice the coriander stalks,
        then add to the pan for 1 minute.<br></br>
        <br></br>
        Stir in the tomatoes and ½ a tin’s worth of hot water, breaking up the
        tomatoes with the back of a wooden spoon. <br></br>
        Bring to the boil, reduce the heat to medium-low and simmer for 5
        minutes, or until thickened and reduced.<br></br>
        <br></br>
        Season to taste, carefully transfer to a liquidiser and blitz until
        smooth.<br></br>
        <br></br>
        Divide the vegetable mixture between 8 corn tortillas and roll them up.{" "}
        <br></br>
        Line them up in a snug-fitting baking dish (roughly 20cm x 30cm), with
        the scruffy ends tucked underneath.<br></br>
        <br></br>
        Pour over the tomato sauce, coarsely grate the Cheddar on top and
        crumble over the feta.<br></br>
        Drizzle with a little oil, then pop in the hot oven for 25 minutes, or
        until bubbling and golden.<br></br>
        <br></br>
        Serve scattered with the reserved corn, spring onion and coriander
        leaves. <br></br>
        Delicious with a crisp green salad.<br></br>
      </Typography>
    </Card>
  );
}
